export default __webpack_public_path__ + "static/media/exterior4.d4da86ae.jpg";